
import {
    AFF_CREDENTIALS_RESPONSE,
    AFF_CREDENTIALS_FAILURE,
    AFF_CREDENTIALS_REQUEST,
    CLEAR_EXPERT_BIO_RESULTS
 } from '../../actions/types';
 import { combineReducers } from "redux";


 import AffArticlesReducer from './AffArticlesReducer';
 import AffExpertsReducer from './AffExpertsReducer';

 
 const initialState = {
    credentials: {},
    // intrests: [],
    isFetching: false,
    error: false,
 };

const setFetching = (state, action) => {
    return {
        credentials: {},
        // intrests: [],
        isFetching: true,
        error: false,
    }
}

const setFailure = (state, action) => {
    return {
        ...state,
        isFetching: false,
        error: true,
        credentials: {},
        // intrests: []
    }
}

const setResults = (state, action) => {
    
   let credentials = action.payload.credentials || {};
//    let intrests = action.payload.intrests || [];

    return {
        ...state,
        isFetching: false,
        error: false,
        credentials,
        // intrests
    }
    
}
 
const AffCredentialsReducer =  (state = initialState, action) => {
     switch (action.type) {
        case AFF_CREDENTIALS_RESPONSE:
             return setResults(state,action);
             break;
         
        case AFF_CREDENTIALS_FAILURE:
             return setFailure(state,action);
             break;

        case AFF_CREDENTIALS_REQUEST:
             return setFetching(state, action);

        case CLEAR_EXPERT_BIO_RESULTS:
             return initialState;
       
        default:
             return state;
             break;
     }
 }



export default combineReducers({
    Credentials: AffCredentialsReducer, 
    
    Articles: AffArticlesReducer,
    Collabs: AffExpertsReducer
   
});

 